import { Customer } from '../classes/customer';

export interface CustomerEmailRow {
    IDCustomerEmail?: number;
    FKIDCustomer?: number;
    Email: string;
}

export interface CustomerPick {
    id: number;
    label: string;
    hint: string;
    emails: string[];
    searchText: string;
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function customerEmailAddresses(customer: { emails?: CustomerEmailRow[] | null } | null | undefined): string[] {
    return (customer?.emails || [])
        .map(row => (row?.Email || '').trim())
        .filter(email => email.length > 0);
}

export function customerEmailsLabel(customer: { emails?: CustomerEmailRow[] | null } | null | undefined): string {
    return customerEmailAddresses(customer).join(', ');
}

/** Scarta le righe vuote. Segnala formato non valido, duplicati e lista vuota. */
export function normalizeCustomerEmails(emails: string[]): { emails: string[]; error: string } {
    const cleaned: string[] = [];
    const seen = new Set<string>();
    for (const raw of emails || []) {
        const email = (raw || '').trim();
        if (!email) {
            continue;
        }
        if (!EMAIL_PATTERN.test(email)) {
            return { emails: [], error: `L'indirizzo "${email}" non è valido.` };
        }
        const key = email.toLowerCase();
        if (seen.has(key)) {
            return { emails: [], error: `L'indirizzo "${email}" è ripetuto.` };
        }
        seen.add(key);
        cleaned.push(email);
    }
    if (cleaned.length === 0) {
        return { emails: [], error: 'Inserisci almeno un indirizzo email.' };
    }
    return { emails: cleaned, error: '' };
}

/**
 * Etichetta per il menu clienti. Senza ragione sociale, nome, cognome e
 * partita IVA il cliente non è selezionabile.
 */
export function toCustomerPick(customer: Customer): CustomerPick | null {
    const company = (customer.CompanyName || '').trim();
    const name = (customer.Name || '').trim();
    const surname = (customer.Surname || '').trim();
    const person = [name, surname].filter(part => part.length > 0).join(' ');
    const vat = (customer.VATNumber || '').trim();
    if (!company && !person && !vat) {
        return null;
    }
    const label = company || person || vat;
    const hintParts: string[] = [];
    if (company && person) {
        hintParts.push(person);
    }
    if (vat && label !== vat) {
        hintParts.push('P.IVA ' + vat);
    }
    const emails = customerEmailAddresses(customer);
    const searchText = [label, person, vat, customer.FiscalCode || '', ...emails]
        .join(' ')
        .toLowerCase();
    return {
        id: customer.IDCustomer as number,
        label,
        hint: hintParts.join(' · '),
        emails,
        searchText
    };
}
